// extracted by mini-css-extract-plugin
module.exports = {"row":"comparisonBody_row__2XW84","attributes":"comparisonBody_attributes__1Yglp","checkIcon":"comparisonBody_checkIcon__fJoIu"};